"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ts_money_1 = require("ts-money");
var Category_1 = __importDefault(require("./Category"));
var CategoryValue = /** @class */ (function () {
    function CategoryValue(json) {
        this.category = new Category_1.default(json.category);
        this.salesAmount = ts_money_1.Money.fromInteger(json.salesAmount, ts_money_1.Currencies.MYR);
    }
    Object.defineProperty(CategoryValue.prototype, Symbol.toStringTag, {
        get: function () {
            return 'CategoryValue';
        },
        enumerable: false,
        configurable: true
    });
    return CategoryValue;
}());
exports.default = CategoryValue;
